<ion-card>
  <ion-card-header>
    <ion-card-title>Irattár</ion-card-title>
    <ion-card-subtitle>
      Az elintézett ügyiratok irattárba helyezése, a megőrzési idő figyelése, selejtezés
      és levéltári átadás. Az irattári terv adja a tételszámokat és a megőrzési időket.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-segment [(ngModel)]="nezet" mode="ios">
      <ion-segment-button value="ugyiratok"><ion-label>Ügyiratok</ion-label></ion-segment-button>
      <ion-segment-button value="kolcsonzes"><ion-label>Kölcsönzés</ion-label></ion-segment-button>
      <ion-segment-button value="selejtezes"><ion-label>Selejtezés</ion-label></ion-segment-button>
      <ion-segment-button value="terv"><ion-label>Irattári terv</ion-label></ion-segment-button>
    </ion-segment>

    <div *ngIf="betoltes" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>

    <!-- Ügyiratok -->
    <ng-container *ngIf="nezet === 'ugyiratok' && !betoltes">
      <h3 style="margin-top:16px">Irattárazásra vár ({{ elintezett.length }})</h3>
      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead><tr><th>Iktatószám</th><th>Tárgy</th><th>Tétel</th><th class="szam">Elintézve</th><th>Művelet</th></tr></thead>
          <tbody>
            <tr *ngFor="let u of elintezett">
              <td class="iktszam">{{ u.iktatoszam }}</td>
              <td>{{ u.targy }}</td>
              <td>{{ u.tetelszam || '—' }}</td>
              <td class="szam">{{ u.elintezve }}</td>
              <td>
                <ion-button size="small" fill="clear"
                            (click)="allapot(u, 'irattarban', 'Irattárba helyezed: ' + u.iktatoszam + '?')">
                  Irattárba
                </ion-button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!elintezett.length">Nincs irattárazásra váró ügyirat.</div>
      </div>

      <h3 style="margin-top:20px">Irattárban ({{ irattarban.length }})</h3>
      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead>
            <tr><th>Iktatószám</th><th>Tárgy</th><th class="szam">Irattárba</th>
                <th class="szam">Megőrzés</th><th class="szam">Selejtezhető</th><th>Művelet</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let u of irattarban">
              <td class="iktszam">{{ u.iktatoszam }}</td>
              <td>{{ u.targy }}</td>
              <td class="szam">{{ u.irattarba }}</td>
              <td class="szam" [title]="u.selejtezes_tiltas || ''">
                {{ u.kotelezo_vedett ? 'nem selejtezhető (rendelet)' : (u.megorzes_ev ? u.megorzes_ev + ' év' : 'nem selejtezhető') }}
              </td>
              <td class="szam">
                {{ u.selejtezheto_ev || '—' }}
                <ion-badge color="warning" *ngIf="selejtezheto(u)">esedékes</ion-badge>
              </td>
              <td>
                <ion-badge color="medium" *ngIf="u.eljarasban">selejtezési eljárásban</ion-badge>
                <ion-badge color="tertiary" *ngIf="u.kolcsonzes_id" [title]="u.kolcsonzo">kikölcsönözve</ion-badge>
                <ion-button size="small" fill="clear" *ngIf="!u.kolcsonzes_id" (click)="kolcsonoz(u)">
                  Kölcsönzés
                </ion-button>
                <ion-button size="small" fill="clear"
                            (click)="allapot(u, 'leveltarban', 'Levéltárnak átadva: ' + u.iktatoszam + '?')">
                  Levéltárba
                </ion-button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!irattarban.length">Az irattár üres.</div>
      </div>
      <ion-note color="medium" style="display:block;margin-top:8px;font-size:.8rem">
        Selejtezni a <b>Selejtezés</b> fülön lehet, mert az mindig tételes jegyzőkönyvvel jár –
        egyesével kipipálva nem marad nyoma, mi és milyen döntés alapján került ki.
      </ion-note>
    </ng-container>

    <!-- Kölcsönzés -->
    <ng-container *ngIf="nezet === 'kolcsonzes' && !betoltes">
      <h3 style="margin-top:16px">Kölcsönzések</h3>
      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead>
            <tr><th>Iktatószám</th><th>Tárgy</th><th>Kölcsönző</th><th>Cél</th>
                <th class="szam">Kiadva</th><th class="szam">Vissza</th><th>Művelet</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let k of kolcsonzesek" [class.ervenytelen]="k.visszahozva">
              <td class="iktszam">{{ k.iktatoszam }}</td>
              <td>{{ k.targy }}</td>
              <td>{{ k.kolcsonzo }}</td>
              <td>{{ k.cel || '—' }}</td>
              <td class="szam">{{ k.kiadva }}</td>
              <td class="szam">{{ k.visszahozva || k.visszahozando || '—' }}</td>
              <td>
                <ion-button size="small" fill="clear" *ngIf="!k.visszahozva" (click)="visszavesz(k)">
                  Visszavétel
                </ion-button>
                <ion-badge color="success" *ngIf="k.visszahozva">visszahozva</ion-badge>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!kolcsonzesek.length">Nincs kölcsönzés.</div>
      </div>
    </ng-container>

    <!-- Selejtezés / levéltári átadás -->
    <ng-container *ngIf="nezet === 'selejtezes' && !betoltes">
      <div class="ikt-fejsor" style="margin-top:12px">
        <ion-select label="Művelet" label-placement="stacked" interface="popover"
                    [(ngModel)]="jegyzokonyv.tipus">
          <ion-select-option value="selejtezes">selejtezés</ion-select-option>
          <ion-select-option value="leveltar">levéltári átadás</ion-select-option>
        </ion-select>
        <ion-input label="Jegyzőkönyv száma" label-placement="stacked"
                   [(ngModel)]="jegyzokonyv.jegyzokonyv_szam"></ion-input>
        <ion-input label="Levéltár" label-placement="stacked" [(ngModel)]="jegyzokonyv.leveltar"
                   placeholder="pl. … Vármegyei Levéltár"></ion-input>
        <ion-input label="Tervezett időpont" label-placement="stacked" type="date"
                   *ngIf="jegyzokonyv.tipus === 'selejtezes'" [(ngModel)]="jegyzokonyv.tervezett_datum"></ion-input>
        <ion-input label="Indoklás" label-placement="stacked" [(ngModel)]="jegyzokonyv.leiras"
                   style="max-width:320px"></ion-input>
        <ion-button size="small" fill="outline" (click)="mindetSelejtezhetot()">Esedékeseket kijelöl</ion-button>
        <ion-button size="small" color="danger" (click)="selejtez()" [disabled]="!kijelolt.size">
          {{ jegyzokonyv.tipus === 'selejtezes' ? 'Selejtezési jegyzék' : 'Jegyzőkönyv' }} ({{ kijelolt.size }})
        </ion-button>
        <ion-note color="medium" style="flex:1 1 100%;font-size:.78rem" *ngIf="jegyzokonyv.tipus === 'selejtezes'">
          A selejtezés három lépés (20/2012. EMMI r. 86. § (2)): a jegyzék elkészítése, a <b>levéltári bejelentés</b>,
          majd – legkorábban a bejelentéstől számított {{ bejelentesNap }}. napon, az igazgató elrendelésével – a végrehajtás.
          A rendelet szerint nem selejtezhető iratok (törzslap, póttörzslap, beírási napló, iktatókönyv, selejtezési
          jegyzőkönyv, intézménylétesítés) nem jelölhetők ki.
        </ion-note>
      </div>

      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead>
            <tr><th style="width:36px"></th><th>Iktatószám</th><th>Tárgy</th><th>Tétel</th>
                <th class="szam">Selejtezhető</th><th>Megjegyzés</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let u of irattarban">
              <td><ion-checkbox [checked]="kivan(u)" [disabled]="!kijelolheto(u)"
                                (ionChange)="valt(u, $event.detail.checked)"></ion-checkbox></td>
              <td class="iktszam">{{ u.iktatoszam }}</td>
              <td>{{ u.targy }}</td>
              <td>{{ u.tetelszam || '—' }}</td>
              <td class="szam">
                {{ u.selejtezheto_ev || '—' }}
                <ion-badge color="warning" *ngIf="selejtezheto(u)">esedékes</ion-badge>
              </td>
              <td>
                <ion-badge color="tertiary" *ngIf="u.kolcsonzes_id">kikölcsönözve – előbb vissza</ion-badge>
                <ion-badge color="medium" *ngIf="u.eljarasban">selejtezési eljárásban</ion-badge>
                <ion-note color="medium" *ngIf="u.selejtezes_tiltas">{{ u.selejtezes_tiltas }}</ion-note>
                <ion-note color="medium" *ngIf="!u.selejtezes_tiltas && !u.megorzes_ev">nincs megőrzési idő – nem selejtezhető</ion-note>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!irattarban.length">Az irattár üres.</div>
      </div>

      <h3 style="margin-top:20px">Selejtezési eljárások és jegyzőkönyvek</h3>

      <!-- Az épp szerkesztett lépés: levéltári bejelentés vagy végrehajtás -->
      <div class="ikt-fejsor" *ngIf="szerk" style="margin:8px 0;padding:8px;border:1px solid var(--ion-color-medium);border-radius:6px">
        <ng-container *ngIf="szerk.mod === 'bejelentes'">
          <b style="flex:1 1 100%">Bejelentés a levéltárnak (20/2012. EMMI r. 86. § (2))</b>
          <ion-input label="Bejelentés napja" label-placement="stacked" type="date" [(ngModel)]="szerk.bejelentve"></ion-input>
          <ion-input label="Levéltár" label-placement="stacked" [(ngModel)]="szerk.leveltar"></ion-input>
          <ion-input label="A bejelentés iktatószáma" label-placement="stacked" [(ngModel)]="szerk.bejelentes_iktatoszam"></ion-input>
          <ion-input label="Tervezett selejtezés" label-placement="stacked" type="date" [(ngModel)]="szerk.tervezett_datum"></ion-input>
          <ion-note color="medium" style="flex:1 1 100%;font-size:.78rem">
            A tervezett időpont legalább {{ bejelentesNap }} nappal a bejelentés után lehet; ha üresen hagyod, a legkorábbi lehetséges nap lesz.
          </ion-note>
        </ng-container>
        <ng-container *ngIf="szerk.mod === 'vegrehajtas'">
          <b style="flex:1 1 100%">Selejtezés végrehajtása ({{ szerk.tetel_db }} tétel) – legkorábban {{ szerk.ettol }}</b>
          <ion-input label="Selejtezés napja" label-placement="stacked" type="date" [(ngModel)]="szerk.datum"></ion-input>
          <ion-input label="Elrendelte (igazgató)" label-placement="stacked" [(ngModel)]="szerk.elrendelte"></ion-input>
          <ion-input label="Jegyzőkönyv száma" label-placement="stacked" [(ngModel)]="szerk.jegyzokonyv_szam"></ion-input>
        </ng-container>
        <ion-button size="small" [color]="szerk.mod === 'vegrehajtas' ? 'danger' : 'primary'" (click)="szerkMent()">
          {{ szerk.mod === 'vegrehajtas' ? 'Selejtezés végrehajtása' : 'Bejelentés rögzítése' }}
        </ion-button>
        <ion-button size="small" fill="clear" (click)="szerk = null">Mégse</ion-button>
      </div>

      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead><tr><th class="szam">Dátum</th><th>Típus / állapot</th><th>Szám</th>
                     <th class="szam">Tétel</th><th>Levéltári bejelentés</th><th>Készítette</th><th>Indoklás</th><th>Művelet</th></tr></thead>
          <tbody>
            <tr *ngFor="let j of jegyzokonyvek" [class.ervenytelen]="j.allapot === 'visszavonva'">
              <td class="szam">{{ j.vegrehajtva || j.tervezett_datum || j.datum }}</td>
              <td>
                {{ j.tipus === 'selejtezes' ? 'selejtezés' : 'levéltári átadás' }}
                <ion-badge *ngIf="j.tipus === 'selejtezes'" [color]="eljarasSzin(j)">{{ eljarasAllapot(j) }}</ion-badge>
              </td>
              <td>{{ j.jegyzokonyv_szam || '—' }}</td>
              <td class="szam">{{ j.tetel_db }}</td>
              <td>
                <ng-container *ngIf="j.bejelentve">
                  {{ j.bejelentve }} · {{ j.leveltar }}
                  <span *ngIf="j.bejelentes_iktatoszam"> ({{ j.bejelentes_iktatoszam }})</span>
                  <div *ngIf="j.allapot === 'bejelentve'" style="font-size:.78rem">
                    végrehajtható: {{ j.vegrehajthato_ettol }}-tól
                    <ion-badge color="success" *ngIf="j.vegrehajthato">esedékes</ion-badge>
                  </div>
                </ng-container>
                <span *ngIf="!j.bejelentve && j.allapot === 'tervezett'">még nincs bejelentve</span>
                <span *ngIf="!j.bejelentve && j.allapot !== 'tervezett'">—</span>
              </td>
              <td>{{ j.keszitette }}<span *ngIf="j.elrendelte"> · elrendelte: {{ j.elrendelte }}</span></td>
              <td>{{ j.leiras || j.visszavonas_indok || '—' }}</td>
              <td style="white-space:nowrap">
                <ion-button size="small" fill="clear" (click)="jegyzekNyomtat(j)">Jegyzék</ion-button>
                <ion-button size="small" fill="clear" *ngIf="j.allapot === 'tervezett'" (click)="bejelentesNyit(j)">Bejelentés</ion-button>
                <ion-button size="small" fill="clear" color="danger" *ngIf="j.allapot === 'bejelentve'"
                            [disabled]="!j.vegrehajthato" (click)="vegrehajtasNyit(j)"
                            [title]="j.vegrehajthato ? '' : 'A bejelentéstől számított ' + bejelentesNap + ' nap még nem telt el.'">
                  Végrehajtás
                </ion-button>
                <ion-button size="small" fill="clear" color="medium"
                            *ngIf="j.allapot === 'tervezett' || j.allapot === 'bejelentve'" (click)="visszavon(j)">Visszavonás</ion-button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!jegyzokonyvek.length">Még nincs selejtezési eljárás vagy jegyzőkönyv.</div>
      </div>
    </ng-container>

    <!-- Irattári terv -->
    <ng-container *ngIf="nezet === 'terv' && !betoltes">
      <div class="ikt-fejsor" style="margin-top:14px">
        <ion-input label="Év" label-placement="stacked" type="number" [(ngModel)]="tervEv"
                   (ionBlur)="betolt()"></ion-input>
        <ion-button size="small" fill="outline" (click)="ujTetel()">
          <ion-icon slot="start" name="add-outline"></ion-icon>Új tétel
        </ion-button>
        <ion-button size="small" fill="outline" (click)="tervFajl.click()">
          <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>Importálás Excelből
        </ion-button>
        <ion-button size="small" fill="outline" (click)="alapElonezet()">
          <ion-icon slot="start" name="library-outline"></ion-icon>Alapértelmezett irattári terv betöltése
        </ion-button>
        <input #tervFajl type="file" accept=".xlsx,.xls,.csv" hidden (change)="tervImport($event)" />
        <ion-button size="small" (click)="tervMent()">
          <ion-icon slot="start" name="save-outline"></ion-icon>Terv mentése
        </ion-button>
        <ion-note color="warning" *ngIf="tervImportalt" style="flex:1 1 100%;font-weight:600">
          Az Excelből betöltött {{ terv.length }} tétel még nincs mentve – nézd át, és kattints a „Terv mentése” gombra.
        </ion-note>
        <ion-note color="medium" style="flex:1 1 100%;font-size:.78rem">
          Az irattári terv az iratkezelési szabályzat kötelező melléklete, évente felülvizsgálandó.
          A tételszámhoz rendelt megőrzési idő adja az ügyirat selejtezhetőségének évét.
          Importálható a KRÉTA irattári terv exportja is (Tételszám, Tárgy, Megőrzési mód, Csoport,
          Megőrzési határidő): az örökös megőrzésű és a levéltári tételek nem selejtezhetők.
        </ion-note>
      </div>

      <!-- Alapértelmezett terv előnézete: csak a hiányzó tételek vehetők fel, a meglévők nem változnak. -->
      <div *ngIf="alapNyitva" style="margin:10px 0;padding:8px;border:1px solid var(--ion-color-medium);border-radius:6px">
        <div *ngIf="alapToltodik" class="ion-text-center"><ion-spinner name="crescent"></ion-spinner></div>
        <ng-container *ngIf="alapAdat && !alapToltodik">
          <b>{{ alapAdat.forras?.jogszabaly }} – {{ alapAdat.forras?.hely }}</b>
          <div style="font-size:.78rem;margin:4px 0">
            Hatályos szöveg: {{ alapAdat.forras?.hatalyos_allapot }} (njt.hu). A {{ alapAdat.ev }}. évi tervben most
            {{ alapAdat.meglevo_db }} tétel van. Csak a kijelölt, „felvehető” tételek kerülnek fel, a terv végére;
            a meglévő tételekhez a program nem nyúl. A rendelet levéltári jelölést nem tartalmaz – azt a tételeken
            kell beállítani, ha a levéltárral így egyeztetett.
          </div>
          <ul style="font-size:.75rem;margin:2px 0 6px 16px;padding:0">
            <li *ngFor="let m of alapAdat.forras?.megjegyzesek">{{ m }}</li>
          </ul>
          <div class="ikt-tabla-doboz">
            <table class="ikt-tabla">
              <thead><tr><th style="width:36px"></th><th>Tételszám</th><th>Megnevezés</th><th>Csoport</th>
                         <th class="szam">Őrzési idő</th><th>Állapot</th></tr></thead>
              <tbody>
                <tr *ngFor="let t of alapAdat.tetelek" [class.ervenytelen]="t.allapot !== 'uj'">
                  <td><ion-checkbox [checked]="alapKijelolt.has(t.kulcs)" [disabled]="t.allapot !== 'uj'"
                                    (ionChange)="alapValt(t, $event.detail.checked)"></ion-checkbox></td>
                  <td>{{ t.tetelszam }}</td>
                  <td>{{ t.megnevezes }}</td>
                  <td>{{ t.csoport }}</td>
                  <td class="szam">{{ t.megorzes_ev ? t.megorzes_ev + ' év' : t.orzesi_ido_szoveg }}</td>
                  <td>
                    {{ alapAllapotSzoveg(t) }}
                    <span *ngIf="t.meglevo" style="font-size:.75rem"> ({{ t.meglevo.tetelszam }} {{ t.meglevo.megnevezes }})</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="ikt-fejsor" style="margin-top:6px">
            <ion-button size="small" (click)="alapBetolt()" [disabled]="!alapKijelolt.size">
              Kijelöltek felvétele ({{ alapKijelolt.size }})
            </ion-button>
            <ion-button size="small" fill="clear" (click)="alapNyitva = false">Bezár</ion-button>
          </div>
        </ng-container>
      </div>

      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead>
            <tr><th>Tételszám</th><th>Megnevezés</th><th>Csoport</th><th class="szam">Megőrzés (év)</th>
                <th>Nem selejtezhető</th><th>Levéltári</th><th></th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of terv; let i = index">
              <td><ion-input [(ngModel)]="t.tetelszam" placeholder="pl. 1.2"></ion-input></td>
              <td class="ikt-terv-megnevezes">
                <!-- Tördelt, automatikusan magasodó mező: a hosszú megnevezés teljes szövege látszik (#1101). -->
                <ion-textarea class="ikt-terv-megnevezes-mezo" [autoGrow]="true" rows="1"
                              [(ngModel)]="t.megnevezes" placeholder="pl. Tanulói jogviszony iratai"></ion-textarea>
              </td>
              <td><ion-input [(ngModel)]="t.csoport" placeholder="pl. Gazdasági ügyek"></ion-input></td>
              <td class="szam"><ion-input type="number" [(ngModel)]="t.megorzes_ev" [disabled]="!!t.kotelezo_vedett"></ion-input></td>
              <td [title]="t.kotelezo_vedett || ''">
                <!-- A rendelet szerint nem selejtezhető tétel nem állítható át (a szerver is kikényszeríti). -->
                <ion-checkbox [checked]="!!t.nem_selejtezheto || !!t.kotelezo_vedett" [disabled]="!!t.kotelezo_vedett"
                              (ionChange)="t.nem_selejtezheto = $event.detail.checked ? 1 : 0"></ion-checkbox>
                <ion-icon name="lock-closed-outline" *ngIf="t.kotelezo_vedett" style="margin-left:4px"></ion-icon>
              </td>
              <td>
                <ion-checkbox [checked]="!!t.leveltari"
                              (ionChange)="t.leveltari = $event.detail.checked ? 1 : 0"></ion-checkbox>
              </td>
              <td>
                <ion-button size="small" fill="clear" color="danger" (click)="torolTetel(i)">
                  <ion-icon slot="icon-only" name="close"></ion-icon>
                </ion-button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!terv.length">
          Nincs irattári terv erre az évre. Vidd fel a tételeket, vagy importáld Excelből.
        </div>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
